"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldTriggerLoginRedirect = exports.isAdmin = exports.getUserRoles = exports.useAuthentication = exports.getAccessToken = void 0;
const auth0_react_1 = require("@auth0/auth0-react");
const getAccessToken = async (getAccessTokenSilently) => {
    const token = await getAccessTokenSilently({
        authorizationParams: {
            redirect_uri: window.location.origin,
            scope: "openid profile email roles offline_access",
            audience: "https://api.ahticlimate.com/v1/",
        },
    });
    return token;
};
exports.getAccessToken = getAccessToken;
const useAuthentication = () => {
    const { user, getAccessTokenSilently } = (0, auth0_react_1.useAuth0)();
    const getAuthHeader = (accessToken) => {
        // Generate auth token
        return { Authorization: `Bearer ${accessToken}` };
    };
    return {
        user,
        getAuthHeader,
        getAccessTokenSilently,
    };
};
exports.useAuthentication = useAuthentication;
const getUserRoles = (user) => {
    return user?.["https://ahti-calculator.netlify.app/roles"];
};
exports.getUserRoles = getUserRoles;
const isAdmin = (user) => {
    const roles = (0, exports.getUserRoles)(user);
    return roles !== undefined && roles.includes("Admin");
};
exports.isAdmin = isAdmin;
const AUTH_REDIRECT_ERROR_CODES = new Set([
    "login_required",
    "consent_required",
    "interaction_required",
    "missing_refresh_token",
    "invalid_grant",
]);
const AUTH_REDIRECT_MESSAGE_HINTS = [
    "no access token available",
    "login required",
    "missing refresh token",
];
const shouldTriggerLoginRedirect = (error, status) => {
    if (status === 401 || status === 403) {
        return true;
    }
    if (!error || typeof error !== "object") {
        return false;
    }
    const parsed = error;
    const errorCode = (typeof parsed.error === "string" ? parsed.error : undefined) ??
        (typeof parsed.code === "string" ? parsed.code : undefined);
    if (errorCode && AUTH_REDIRECT_ERROR_CODES.has(errorCode)) {
        return true;
    }
    const message = (typeof parsed.message === "string" ? parsed.message : undefined) ??
        (typeof parsed.error_description === "string"
            ? parsed.error_description
            : undefined);
    if (!message) {
        return false;
    }
    const normalizedMessage = message.toLowerCase();
    return AUTH_REDIRECT_MESSAGE_HINTS.some((hint) => normalizedMessage.includes(hint));
};
exports.shouldTriggerLoginRedirect = shouldTriggerLoginRedirect;
